import Tile from "./Tile";
import TileThemes from "./TileThemes";

export { TileThemes };
export default Tile;
